import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Utils from '../../utility';
import { GlobalService } from '../../../services/global.service';
import { FundingSourceComponent } from '../funding-source/funding-source.component';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-substantial-earnings-calculator',
  templateUrl: './substantial-earnings-calculator.component.html',
  styleUrls: ['./substantial-earnings-calculator.component.css']
})
export class SubstantialEarningsComponent implements OnInit {

  data;
  client;
  isSpouse: boolean = false;
  substantialEarningsForm: FormGroup;
  dataSource: any[] = [];
  currentYear = new Date().getFullYear();
  displayCalcBtn: boolean = false;

  yob;
  endOfSubstantialEarningsStartYear;
  endYear1;
  endOfSubstantialEarningsEndYear;

  constructor(private formBuilder: FormBuilder, private globalService: GlobalService, public dialogRef: MatDialogRef<FundingSourceComponent>, @Inject(MAT_DIALOG_DATA) data) {
    this.data = data.substantialEarningsData;
    this.client = data.client;
    this.isSpouse = data.isSpouse;
  }

  ngOnInit() {
    var dateofBirth = new Date(((this.isSpouse) ? this.client.clientProfile.Spouses[0].dob : this.client.client.DOB)).getFullYear();
    this.yob = dateofBirth + 14;
    this.endOfSubstantialEarningsStartYear = this.currentYear - this.yob + 1;
    this.endYear1 = dateofBirth + 30;
    var endYear2 = dateofBirth + 80;
    this.endOfSubstantialEarningsEndYear = endYear2 - this.endYear1 + 1;
    this.substantialEarningsForm = this.formBuilder.group({
      startYear: [(this.data && this.data.startYear) ? this.data.startYear.toString() : '', [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.min(this.yob), Validators.max(this.yob + this.endOfSubstantialEarningsStartYear)]],
      endYear: [(this.data && this.data.endYear) ? this.data.endYear.toString() : '', [Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
      substantialEarningsYearArray: new FormArray([])
    });
    
    if (this.data && this.data.details && this.data.details.length) {
      this.displayCalcBtn = true;
      for (let i = 0; i <= this.data.details.length; i++) {
        if (this.data.details[i] && this.data.details[i].ActualEarnings >= 0)
          this.addSubstantialEarningsYear(this.data.details[i].Year, Utils.formatToCurrency(this.data.details[i].ActualEarnings));
      }
    }
  }

  formatCurrency(val, i) {
    val = val.replace(/\D/g, '');
    (<FormArray>(<FormArray>this.substantialEarningsForm.controls['substantialEarningsYearArray']).controls[i]).controls['ActualEarnings'].patchValue(val ? Utils.formatToCurrency(Utils.formatToNumber(val)) : '');
  }

  close(update): void {
    if (update) {
      for (var year of this.substantialEarningsForm.value.substantialEarningsYearArray) {
        year.ActualEarnings = Number(year.ActualEarnings ? year.ActualEarnings.replace('$', '').replace(/,/g, '') : 0);
      }
      this.getSubstantialEarningYearsObject()
    } else {
      if (this.substantialEarningsForm.value.length > 0) {
        for (var year of this.substantialEarningsForm.value.substantialEarningsYearArray) {
          year.ActualEarnings = Number(year.ActualEarnings ? year.ActualEarnings.replace('$', '').replace(/,/g, '') : 0);
        }
        this.getSubstantialEarningYearsObject()
      } else {
        this.dialogRef.close();
      }
    }
  }

  get substantialEarningsYears() {
    return this.substantialEarningsForm.controls["substantialEarningsYearArray"] as FormArray;
  }

  onChangeSubstantialEarningsYear() {
    this.substantialEarningsForm.get('endYear').setValidators([Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.min(this.substantialEarningsForm.value.startYear)])
    this.substantialEarningsForm.get('endYear').updateValueAndValidity()

    if (this.displayCalcBtn) {
      this.calculateSubstantialEarningsYears();
    }
  }

  calculateSubstantialEarningsYears() {
    let temp = {}
    if (this.substantialEarningsForm.get('startYear').valid && this.substantialEarningsForm.get('endYear').valid) {
      for (let i = 0; i <= (this.substantialEarningsForm.value.endYear - this.substantialEarningsForm.value.startYear); i++) {
        const year = Number(this.substantialEarningsForm.value.startYear) + i;

        if (year >= Number(this.substantialEarningsForm.get('startYear').value) && year <= Number(this.substantialEarningsForm.get('endYear').value)) {
            this.addSubstantialEarningsYear(year, '$0');
        }
      }
    }

    this.displayCalcBtn = true;
  }

  getSubstantialEarningYearsObject() {
    let years = 0;
    this.globalService.getSubstantialEarningYears()
      .subscribe(
        data => {
          let substantialEarningsYear;
          let seyTable = [];
          this.substantialEarningsForm.value.substantialEarningsYearArray.forEach(sey => {
            substantialEarningsYear = data.find(y => y.StartYear >= sey.Year && y.EndYear >= sey.Year)
            if (substantialEarningsYear && sey.ActualEarnings > substantialEarningsYear.Amount) {
              let seyDate = new Date(this.client.client.DOB)
              seyDate.setFullYear(sey.Year)
              sey.age = this.getCurrentAgeByDOB(this.client.client.DOB) - this.getCurrentAgeByDOB(seyDate)
              seyTable.push(sey)
              years++;
            }
          })
          
          this.dialogRef.close({startYear: this.substantialEarningsForm.value.startYear, endYear: this.substantialEarningsForm.value.endYear, substantialEarningYears: years, seyTable, details: this.substantialEarningsForm.value.substantialEarningsYearArray });
        },
        error => console.log(error));
  }

  addSubstantialEarningsYear(year, value) {
    this.removeSEYears()

    const yearObj = new FormGroup(
      {
        Year: new FormControl(year),
        ActualEarnings: new FormControl(value || 0, [Validators.required])
      }
    )

    const seYearIdx = this.substantialEarningsYears.value.findIndex(y => y.Year === yearObj.value.Year)

    if (seYearIdx > -1)
      this.substantialEarningsYears.value[seYearIdx] = yearObj;
    else if (seYearIdx === -1)
      this.substantialEarningsYears.push(yearObj);
    
    this.substantialEarningsForm.controls['substantialEarningsYearArray'].patchValue(this.substantialEarningsForm.get('substantialEarningsYearArray').value.sort((a,b) => {
      return a.Year < b.Year ? -1 : 1
    }))

  }

  getCurrentAgeByDOB(birthday){
    var dob = new Date(birthday);
    const startYear = new Date();
    var CurrentAgeOffset = ((startYear.getMonth() + 1) < (dob.getMonth() + 1)) ? 1 : 0;
    return Math.floor(((((startYear.getFullYear() - dob.getFullYear()) * 12) + (startYear.getMonth() + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset));
  }

  removeSEYears() {
    // Weird behavior - running this loop twice removes years outside of our validation
    // Running this loop once for some reason has gaps and adds years that it shouldn't
    // This works for now but is questionable
    let idx = 0;
    while (idx < this.substantialEarningsYears.value.length) {
      let year = (<FormArray>(<FormArray>this.substantialEarningsForm.controls['substantialEarningsYearArray']).controls[idx]).controls['Year'].value
      if (year < Number(this.substantialEarningsForm.get('startYear').value) || year > Number(this.substantialEarningsForm.get('endYear').value)) {
        const control = <FormArray>(this.substantialEarningsForm.controls['substantialEarningsYearArray'])
        control.removeAt(idx)
      }
      idx++;
    }

    idx = 0;
    while (idx < this.substantialEarningsYears.value.length) {
      let year = (<FormArray>(<FormArray>this.substantialEarningsForm.controls['substantialEarningsYearArray']).controls[idx]).controls['Year'].value
      if (year < Number(this.substantialEarningsForm.get('startYear').value) || year > Number(this.substantialEarningsForm.get('endYear').value)) {
        const control = <FormArray>(this.substantialEarningsForm.controls['substantialEarningsYearArray'])
        control.removeAt(idx)
      }
      idx++;
    }

    if (this.substantialEarningsForm.value.startYear == this.substantialEarningsForm.value.endYear) {
      idx = 0;
      while (this.substantialEarningsYears.value.length > 0) {
        const control = <FormArray>(this.substantialEarningsForm.controls['substantialEarningsYearArray'])
        control.removeAt(this.substantialEarningsYears.value.length - idx)
        idx++;
      }
      this.substantialEarningsForm.controls['substantialEarningsYearArray'].patchValue([this.substantialEarningsForm.get('substantialEarningsYearArray').value[0]])
    }
  }
}